import React, { useEffect } from 'react';
import { Page } from '@wix/design-system';
import {
  useEssentials,
  useJunkYard,
  useRouterContext,
  AppMarketPage,
  getPageViewBiData,
  usePageLoad,
} from '@wix/app-market-core';
import {
  appMarketPageStartLoadedSrc24Evid163,
  appMarketPageView,
} from '@wix/bi-logger-app-market-data/v2';
import { withSaleBanner } from '../../components/sale-banner';
import { CollectionAppsSection } from './collection-apps-section';
import { CollectionHeader } from './collection-header';
import s from '../pages.scss';

const CollectionPageComponent = function ({ slug }: { slug: string }) {
  const { biLogger } = useEssentials();
  const { route } = useRouterContext();
  const { routerData } = useJunkYard();

  usePageLoad({
    route,
    oldRoute: routerData.route,
    onLoad: () =>
      biLogger.report(
        appMarketPageView(
          getPageViewBiData({
            routerData,
            pageType: AppMarketPage.COLLECTION,
            pageName: slug,
          }),
        ),
      ),
  });

  useEffect(() => {
    biLogger.report(
      appMarketPageStartLoadedSrc24Evid163({
        tag_type: AppMarketPage.COLLECTION,
      }),
    );
  }, [slug]);

  return (
    <Page className={`${s.appMarketPage} ${s.appMarketPageBackgroundColor}`}>
      <Page.Content>
        <CollectionHeader slug={slug} />
        <CollectionAppsSection slug={slug} />
      </Page.Content>
    </Page>
  );
};

const CollectionPageWithBanner = withSaleBanner(CollectionPageComponent);

export const CollectionPage = (props: { slug: string }) =>
  props.slug === 'holiday-sale' ? (
    <CollectionPageComponent {...props} />
  ) : (
    <CollectionPageWithBanner {...props} />
  );
